import { flow, types } from "mobx-state-tree";
import projectAPI from "./ProjectService";

export const ProjectDropdownStore = types
    .model("ProjectDropdownStore", {
        options: types.optional(types.array(types.frozen()), []),
        loading: types.optional(types.boolean, false),
        selectedProject: types.maybeNull(types.frozen()),
    })
    .views((self: any) => ({
        get projectOptions() {
            return self.options.map((project: any) => ({
                text: project.projectTHName,
                value: project.projectID,
            }));
        }
    }))
    .actions((self: any) => ({
        loadProjects: flow(function*(searchText?: string, organizationID?: number) {
            try {
                self.loading = true;
                
                const result = yield projectAPI.getProjectList({
                    organizationID: organizationID || null,
                    projectType: null,
                    startYear: null,
                    newiipmFilter: null,
                    paging: {
                        pageSize: 50,
                        pageNo: 1,
                        searchText: searchText
                    },
                    plan: false,
                    planId: null,
                    IsCanceled: 0,
                    source: null,
                    onlend: true // เพิ่มการค้นหาโครงการที่เป็น ONLEND
                });
                
                let projectList = [];
                if (Array.isArray(result!.data)) {
                    projectList = result.data;
                } else if (Array.isArray(result!.list)) {
                    projectList = result.list;
                } else if (Array.isArray(result)) {
                    projectList = result;
                }
                
                self.options = projectList;
                
            } catch (e) {
                console.log(e);
            } finally {
                self.loading = false;
            }
        }),
loadProjectById: flow(function*(projectID: number) {
            try {
                // ถ้ามีในรายการแล้ว ไม่ต้องโหลดใหม่
                const existingProject = self.options.find((p: any) => p.projectID === projectID);
                if (existingProject) {
                    console.log("Project found in cache:", existingProject);
                    return existingProject;
                }
                
                self.loading = true;
                console.log("Loading project by ID:", projectID);
                
                // โหลดข้อมูลโครงการตัวเดียวจาก API
                const result = yield projectAPI.getProjectDetails(projectID);
                
                if (result && result.data) {
                    // เพิ่มลงใน options array
                    self.options.push(result.data);
                    console.log("Project loaded and added to cache:", result.data);
                    return result.data;
                }
                
                return null;
            } catch (e) {
                console.log("Error loading project by ID:", e);
                return null;
            } finally {
                self.loading = false;
            }
        }),
        setSelectedProject: (project: any) => {
            self.selectedProject = project;
        },

        reset: () => {
            self.options = [];
            self.selectedProject = null;
        }
    }),

);
    

export type IProjectDropdownStore = typeof ProjectDropdownStore.Type;